import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lC5w8"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("dgnbp"), parcelRequire.load("2qc6w"), parcelRequire.load("g56vt"), parcelRequire.load("jwvyQ"), parcelRequire.load("iipXm"), parcelRequire.load("d4VSw"), parcelRequire.load("hCFJT"), parcelRequire.load("fFjD1"), parcelRequire.load("lH05e"), parcelRequire.load("45RYB"), parcelRequire.load("6ZqMg"), parcelRequire.load("dRxJe")]).then(() => {
let originalModule = parcelRequire("7ohac");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("dgnbp")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lC5w8")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("2qc6w")} />
  <link rel="modulepreload" href={parcelRequire.resolve("g56vt")} />
  <link rel="modulepreload" href={parcelRequire.resolve("jwvyQ")} />
  <link rel="modulepreload" href={parcelRequire.resolve("iipXm")} />
  <link rel="modulepreload" href={parcelRequire.resolve("d4VSw")} />
  <link rel="modulepreload" href={parcelRequire.resolve("hCFJT")} />
  <link rel="modulepreload" href={parcelRequire.resolve("fFjD1")} />
  <link rel="modulepreload" href={parcelRequire.resolve("lH05e")} />
  <link rel="modulepreload" href={parcelRequire.resolve("45RYB")} />
  <link rel="modulepreload" href={parcelRequire.resolve("6ZqMg")} />
  <link rel="modulepreload" href={parcelRequire.resolve("dRxJe")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
